import { Component, inject, Input } from '@angular/core';
import { ICON } from '@core/util/icon';
import { Note } from '@models/matter-notes';
import { MatterNotesDispatch } from '@state/matter/notes';
import { ModalService } from '@ui/modal/modal.service';
import { UI_TYPES } from 'src/app/ui/modal/modal.types';
import {
	CreateNoteComponent,
	CreateNoteData,
} from '../../create-note/create-note.component';
import { DeleteNoteConfirmationComponent } from './delete-note-confirmation/delete-note-confirmation.component';
import { TestHooks } from './note.hooks';

@Component({
	selector: 'app-note',
	templateUrl: './note.component.html',
	styleUrls: ['./note.component.scss'],

	standalone: false,
})
export class NoteComponent {
	testHooks = TestHooks;
	modalService = inject(ModalService);
	@Input() note: Note;

	public ICON = ICON;

	constructor(private noteDispatch: MatterNotesDispatch) {}

	updateNote(id: string): void {
		const data: CreateNoteData = { id };
		this.modalService.openModal(CreateNoteComponent, {
			title: 'Edit note',
			data,
		});
	}

	onDeleteNote(noteId: string): void {
		this.modalService.openModal(DeleteNoteConfirmationComponent, {
			title: 'Delete note',
			type: UI_TYPES.DANGER,
			data: { noteId },
			size: 'sm',
		});
	}

	deleteNote(noteId: string): void {
		this.noteDispatch.Remove(noteId);
	}

	updatePinned(pinned) {
		this.noteDispatch.SetPinned(this.note.id, pinned);
	}
}
